import { get, post } from "../utils/request";

/**
 * 用户登录
 * @param {实例对象this} vm
 * @param {回调函数} cb
 */
export const login = (vm, cb) => {
  let param = {
    account: vm.phone,
    password: vm.password
  };
  post("/api/front/login", param)
    .then(res => {
      if (res.code === 200) {
        vm.$notify({
          title: "提示",
          type: "success",
          message: "登录成功"
        });
      } else {
        vm.$notify({
          title: "提示",
          type: "error",
          message: res.message
        });
      }
      if (cb !== undefined) {
        cb(res);
      }
    })
    .catch(error => {
      //console.log(error);
      vm.$tips_error(vm, error);
    });
};

/**
 * 用户注册
 * @param {实例对象this} vm
 * @param {回调函数} cb
 */
export const register = (vm, cb) => {
  let param = {
    account: vm.phone,
    verifyCode: vm.verifyCode,
    password: vm.password
  };
  post("/api/front/register", param)
    .then(res => {
      vm.isLoading = false;
      if (res.code == 200) {
        vm.$notify({
          title: "提示",
          type: "success",
          message: "注册成功"
        });
        vm.$router.push({
          name: "login"
        });
      } else if (res.code == 301) {
        vm.$notify({
          title: "提示",
          message: res.message,
          type: "error"
        });
      } else {
        vm.$notify({
          title: "提示",
          message: "注册失败：" + JSON.stringify(res),
          type: "error"
        });
      }
      if (cb !== undefined) {
        cb(res);
      }
    })
    .catch(error => {
      //console.log(error);
      vm.$tips_error(vm, error);
    });
};

/**
 * 获取手机验证码
 * @param {实例对象this} vm
 * @param {回调函数} cb
 */
export const getVerifyCode = (vm, cb) => {
  let param = {
    phone: vm.phone ? vm.phone : vm.form.phone
  };
  post("/api/front/getCode", param)
    .then(res => {
      let bool = true;
      if (res.code == 200) {
        bool = true;
        var timer = vm.$notify({
          title: "提示",
          message: "验证码发送成功！",
          type: "success"
        });
        setTimeout(() => {
          timer.close();
        }, 1500);
      } else if (res.code == 314) {
        bool = false;
        vm.$notify({
          title: "提示",
          message: "验证码发送过于频繁，请稍后再试",
          type: "error"
        });
      } else {
        bool = false;
        vm.$notify({
          title: "提示",
          message: "验证码发送失败: " + JSON.stringify(res),
          type: "error"
        });
      }
      if (cb !== undefined) {
        cb(bool);
      }
    })
    .catch(error => {
      vm.$tips_error(vm, error);
      if (cb !== undefined) {
        cb(false);
      }
    });
};

/**
 * 获取邮箱验证码
 * @param {*} vm
 * @param {*} cb
 */
export const getEmailVerifyCode = (vm, cb) => {
  let param = {
    account: vm.phone
  };
  post("/api/front/sendMail", param)
    .then(res => {
      let bool = true;
      if (res.code === 200) {
        bool = true;
        var timer = vm.$notify({
          title: "提示",
          message: "验证码发送成功！",
          type: "success"
        });
        setTimeout(() => {
          timer.close();
        }, 1500);
      } else {
        bool = false;
        vm.$notify({
          title: "提示",
          message: "验证码发送失败: " + JSON.stringify(res),
          type: "error"
        });
      }
      if (cb !== undefined) {
        cb(bool);
      }
    })
    .catch(error => {
      vm.$tips_error(vm, error);
      if (cb !== undefined) {
        cb(false);
      }
    });
};

/**
 * 查看个人基本信息
 * @param {*} vm
 * @param {*} cb
 */
export const getUserInfo = (vm, cb) => {
  let param = {
    id: vm.userInfo.userId
  };
  post("/api/auctionNper/searchFrontUserById", param)
    .then(res => {
      if (res.code === 200) {
        vm.formData = res.data;
      }
      cb && cb();
      vm.$tips_msg(vm, res);
    })
    .catch(error => {
      vm.$tips_error(vm, error);
    });
};

/**
 * 修改密码
 * @param {*} vm
 * @param {*} cb
 */
export const setPassword = (vm, cb) => {
  let param = {
    id: vm.userInfo.userId,
    verifyCode: vm.form.code,
    phone: vm.userInfo.phone,
    password: vm.form.nexPassword,
    oldpass: vm.form.oldPassword
  };
  post("/api/front/updatePass", param)
    .then(res => {
      vm.isLoading = false;
      if (res.code === 200) {
        var a = vm.$notify({
          title: "提示",
          message: "修改成功！",
          type: "success"
        });
        setTimeout(() => {
          a.close();
        }, 1500);
        Object.assign(this.$data, this.$options.data());
        vm.userInfo.phone = vm.phone;
        vm.$store.dispatch("setUserInfo", vm.userInfo);
      } else if (res.code === 302) {
        var ab = vm.$notify({
          title: "提示",
          message: "验证码错误",
          type: "error"
        });
        setTimeout(() => {
          ab.close();
        }, 1500);
      } else if (res.code === 304) {
        var aba = vm.$notify({
          title: "提示",
          message: "用户不存在",
          type: "error"
        });
        setTimeout(() => {
          aba.close();
        }, 1500);
      } else if (res.code === 305) {
        var abc = vm.$notify({
          title: "提示",
          message: "原密码错误",
          type: "error"
        });
        setTimeout(() => {
          abc.close();
        }, 1500);
      } else {
        vm.$notify({
          title: "提示",
          message: "修改失败: " + JSON.stringify(res),
          type: "error"
        });
      }
      cb && cb();
    })
    .catch(error => {
      vm.isLoading = false;
      vm.$tips_error(vm, error);
    });
};

/**
 * 修改手机号码
 * @param {*} vm
 * @param {*} cb
 */
export const setPhone = (vm, cb) => {
  let param = {
    id: vm.userId,
    verifyCode: vm.form.code,
    phone: vm.form.phone
  };
  post("/api/front/updatePhone", param)
    .then(res => {
      vm.isLoading = false;
      if (res.code == 200) {
        vm.$notify({
          title: "提示",
          message: vm.isModify ? "修改成功！" : "绑定成功",
          type: "success"
        });
        vm.$emit("confim", vm.form.phone);
      } else if (res.code == 302) {
        var aa = vm.$notify({
          title: "提示",
          message: "验证码不正确",
          type: "error"
        });
        setTimeout(() => {
          aa.close();
        }, 1500);
      } else {
        vm.$notify({
          title: "提示",
          message: "修改失败: " + res.message,
          type: "error"
        });
      }
      cb && cb();
    })
    .catch(error => {
      vm.isLoading = false;
      cb && cb();
      vm.$tips_error(vm, error);
    });
};

/**
 * 设置用户名
 * @param {*} vm
 * @param {*} cb
 */
export const setName = (vm, cb) => {
  let params = {
    id: vm.userInfo.userId,
    userName: vm.setuserName
  };
  post("/api/front/updatename", params)
    .then(res => {
      if (res.code == 200) {
        vm.$notify({
          title: "提示",
          message: "设置成功！",
          type: "success"
        });
        vm.formData.userName = vm.setuserName;
        vm.userInfo.userName = vm.setuserName;
        vm.$store.dispatch("setUserInfo", vm.userInfo);
      } else {
        vm.$notify({
          title: "提示",
          message: "设置失败: " + res.message,
          type: "error"
        });
        vm.setuserName = vm.formData.userName;
      }
      vm.isShowSetName = false;
    })
    .catch(error => {
      vm.isShowSetName = false;
      vm.$tips_error(vm, error);
    });
};

/**
 * 获取我的消息列表
 * @param {*} vm
 * @param {*} cb
 */
export const getMesgList = (vm, cb) => {
  let param = {
    userId: vm.userId,
    pageNo: vm.current,
    pageSize: vm.display
  };
  vm.list = [];
  vm.isloading = true;
  vm.nodata = false;
  post("/api/message/messageList", param)
    .then(res => {
      vm.isloading = false;
      if (res.code === 200) {
        vm.list = res.data.list || [];
        vm.total = res.data.total;
      }
      cb && cb();
      vm.$tips_msg(vm, res);
      vm.nodata = vm.list.length == 0 ? true : false;
    })
    .catch(error => {
      vm.isloading = false;
      vm.$tips_error(vm, error);
    });
};

/**
 * 获取我的拍卖次数
 * @param {*} vm
 * @param {*} cb
 */
export const getAuctionRecordCount = (vm, cb) => {
  let param = {
    userId: vm.userId
  };
  post("/api/auctionNper/auctionRecord", param)
    .then(res => {
      if (res.code === 200) {
        vm.cardsNumber = res.data.cardsNumber; //举牌次数
        vm.participateNumber = res.data.participateNumber; //参与次数
        vm.seckillNumber = res.data.seckillNumber; //秒杀次数
      }
      if (cb !== undefined) {
        cb();
      }
    })
    .catch(error => {
      //console.log(error);
    });
};

/**
 * 获取我的拍卖记录
 * @param {*} vm
 * @param {*} cb
 * orderStatus   0 逾期 1 已支付 2未支付
 * @param {tabType} url => tabType === 1
 * ? /api/auctionNper/remindListByUserId  设置提醒
 * : /api/auctionNper/userAuctionList     已拍得 未拍得 进行中
 *
 */
export const getAuctionRecordList = (vm, cb) => {
  let param = {
    userId: vm.userInfo.userId,
    pageNo: vm.current,
    pageSize: vm.display
  };
  switch (vm.tabType) {
    case "0":
    case "1":
      param.type = "3";
      break;
    case "2":
      param.type = "1";
      param.orderStatus = vm.selectType;
      break;
    case "3":
      param.type = "2";
      break;
    default:
      break;
  }
  let url =
    vm.tabType === "1"
      ? "/api/auctionNper/remindListByUserId"
      : "/api/auctionNper/userAuctionList";
  vm.isloading = true;
  vm.nodata = false;
  vm.list = [];
  post(url, param)
    .then(res => {
      vm.isloading = false;
      //console.log(res);
      if (res.code === 200) {
        let list = res.data.list || [];
        let itemlist = list.map(element => {
          let item = {};
          item = vm.tabType === "1" ? element.tauctionNper : element;
          if (vm.tabType === "2") {
            item.id = item.order.id;
          }
          item.detailType = vm.tabType !== "2" ? 0 : 1; // 0 => 普通详情, 1 => 含有订单信息详情
          item.imgsUrl = item.imgsUrl
            ? vm.comImgUrl + item.imgsUrl.split("|")[0]
            : "";
          return item;
        });
        vm.list = itemlist;
        vm.total = res.data.total;
      }
      vm.nodata = vm.list.length > 0 ? false : true;
      cb && cb(res);
      vm.$tips_msg(vm, res);
    })
    .catch(error => {
      vm.isloading = false;
      vm.$tips_error(vm, error);
    });
};

/**
 * 获取用户退款记录表
 * @param {*} vm
 * @param {*} cb
 * isRefund  0 未退还  1  已退还
   auctionNperDate  拍卖结束时间
   name 名称   
 */
export const gerRefundList = (vm, cb) => {
  let params = {
    userId: vm.userInfo.userId,
    pageNo: vm.current,
    pageSize: vm.display,
    auctionNperDate: vm.end_date,
    isRefund: vm.typeValue,
    name: vm.keyword
  };
  console.log(vm.end_date);
  vm.isloading = true;
  vm.nodata = false;
  vm.list = [];
  post("/api/front/refundList", params)
    .then(res => {
      vm.isloading = false;
      //console.log(res);
      if (res.code == 200) {
        vm.list = res.data.list || [];
        vm.total = res.data.total;
      }
      vm.nodata = vm.list.length > 0 ? false : true;
      cb && cb(res);
      vm.$tips_msg(vm, res);
    })
    .catch(error => {
      vm.isloading = false;
      vm.$tips_error(vm, error);
      //console.log(error);
    });
};

/**
 * 用户退出登录
 * @param {*} vm
 * @param {*} cb
 */
export const loginOut = (vm, cb) => {
  let params = {
    id: vm.userInfo.userId
  };
  post("/api/front/loginOut", params)
    .then(res => {
      if (cb !== undefined) {
        cb(res);
      }
    })
    .catch(error => {
      //console.log(error);
    });
};

/**
 * 检测是否登录
 * @param {*} vm
 * @param {*} cb
 */
export const checkLogin = params => {
  return post("/api/front/checkLogin", params);
};
